import React, { memo } from 'react';
import { shallowEqual } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { useTypedSelector } from '../../../store';
import Basis from '../Basis/Basis';
import CurrencyForm from '../Currency/CurrencyForm';
import DateOptions from '../DateOptions/DateOptions';
import Edit from '../Edit/Edit';
import StepCard from '../StepCard/StepCard';
import InterestFormAddButton from './InterestForm/InterestFormAddButton';
import InterestFormAlert from './InterestForm/InterestFormAlert';
import InterestFormDueBasis from './InterestForm/InterestFormDueBasis';
import InterestFormOptions from './InterestForm/InterestFormOptions';
import InterestFormPartialSum from './InterestForm/InterestFormPartialSum';
import InterestFormTable from './InterestForm/InterestFormTable';

const InterestForm = () => {

  const { t } = useTranslation();

  const  editKey = useTypedSelector(state =>
    state.edit.key);

  const isCurrencyVisible = useTypedSelector(state =>
    state.currency.isCurrencyVisible);

  const { isBasisVisible, areDateOptionsVisible } = useTypedSelector(state =>
    state.interestFormOptions, shallowEqual);

  if (isCurrencyVisible){
    return (
      <CurrencyForm />
    );
  }

  if (areDateOptionsVisible){
    return (
      <DateOptions />
    );
  }

  if (isBasisVisible){
    return (
      <Basis />
    );
  }

  if (editKey !== null){
    return (
      <Edit />
    );
  }

  return (
    <StepCard title={t('interestForm.title')} desc={t('interestForm.desc')} dividerDisabled>
      <InterestFormTable />
      <InterestFormAlert />
      <InterestFormDueBasis />
      <InterestFormPartialSum />
      <InterestFormAddButton />
      <InterestFormOptions />
    </StepCard>
  );
};

export default memo(InterestForm);
